<div class="container mx-auto p-6">
    <h1 class="text-4xl font-bold mb-8">Agenda</h1>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        @for (evenement of evenements; track $index) {
            <app-evenement-card [headingLevel]="2" [isPrivate]="true" [evenement]="evenement"></app-evenement-card>
        }
    </div>
</div>